import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { IonHeader, IonPage, IonTitle, IonToolbar, useIonToast } from '@ionic/react';

import { inMemoryPersistence, signInAnonymously } from '@firebase/auth';
import { auth, fireStore } from 'utils/firebase';
import { doc, DocumentReference, getDoc } from '@firebase/firestore';
import { ChatClientContent } from 'components/chat/ChatClientContent';
import { ChatFooterForm } from 'components/chat/ChatFooterForm';
import { Chat } from 'models';
import { SENDER_CLIENT } from 'consts';

import styles from './ChatClientPage.module.scss';

export const ChatClientPage: FC = () => {
  const [chat, setChat] = useState<Chat>();
  const chatRoomKey = useParams<{ chatRoomKey: string }>().chatRoomKey;

  const [presentToast] = useIonToast();

  // API停止後は、モデル名をチャット文書（userName）から取得する
  const modelName = chat?.userName || '';

  const getChat = async () => {
    await auth.setPersistence(inMemoryPersistence);
    signInAnonymously(auth)
      .then(async () => {
        const chatDoc = doc(fireStore, 'chats', chatRoomKey) as DocumentReference<Chat>;
        const chat = await getDoc<Chat>(chatDoc);
        setChat(chat.data());
      })
      .catch((e) => {
        console.error(e);
        presentToast({
          message: '通信エラーが発生しました。しばらくたってからもう一度お試しください。',
          duration: 2000,
        });
      });
  };

  useEffect(() => {
    getChat();
  }, []);

  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar className="header">
          <IonTitle className={styles.headerTitle}>{modelName}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {chat ? <ChatClientContent modelName={modelName} /> : null}
      <ChatFooterForm senderType={SENDER_CLIENT} />
    </IonPage>
  );
};
